import { render, staticRenderFns } from "./creative-edit.vue?vue&type=template&id=68828f2a&scoped=true"
import script from "./creative-edit.vue?vue&type=script&lang=js"
export * from "./creative-edit.vue?vue&type=script&lang=js"
import style0 from "./creative-edit.vue?vue&type=style&index=0&id=68828f2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68828f2a",
  null
  
)

export default component.exports